import {
  ANNUAL_DONATION_LIMIT,
  formatManWon,
  FULL_DEDUCTION_LIMIT,
  GIFT_VALUE_RATE_PERCENT,
  HIGH_DEDUCTION_RATE_PERCENT,
  MID_DEDUCTION_LIMIT,
  MID_DEDUCTION_RATE_PERCENT,
} from '@/constants/hometownDonationPolicy';

export const clampToDonationLimit = (value: string) => {
  const parsedAmount = parseInt(value.replace(/,/g, ''), 10);

  if (isNaN(parsedAmount)) {
    return '';
  }

  return String(Math.min(parsedAmount, ANNUAL_DONATION_LIMIT));
};

export const calculateTaxDeduction = (amount: number) => {
  const details: { label: string; value: number }[] = [];

  if (amount <= 0) return { total: 0, details };

  if (amount <= FULL_DEDUCTION_LIMIT) {
    details.push({
      label: `${formatManWon(amount)}만 원 x 100%`,
      value: amount,
    });

    return { total: amount, details };
  }

  details.push({
    label: `${formatManWon(FULL_DEDUCTION_LIMIT)}만 원 x 100%`,
    value: FULL_DEDUCTION_LIMIT,
  });
  let total = FULL_DEDUCTION_LIMIT;

  if (amount <= MID_DEDUCTION_LIMIT) {
    const excess = amount - FULL_DEDUCTION_LIMIT;
    const deduction = Math.floor((excess * MID_DEDUCTION_RATE_PERCENT) / 100);
    details.push({
      label: `${formatManWon(excess)}만 원 x ${MID_DEDUCTION_RATE_PERCENT}%`,
      value: deduction,
    });
    total += deduction;

    return { total, details };
  }

  const midExcess = MID_DEDUCTION_LIMIT - FULL_DEDUCTION_LIMIT;
  const midDeduction = Math.floor(
    (midExcess * MID_DEDUCTION_RATE_PERCENT) / 100,
  );
  details.push({
    label: `${formatManWon(midExcess)}만 원 x ${MID_DEDUCTION_RATE_PERCENT}%`,
    value: midDeduction,
  });
  total += midDeduction;

  const highExcess = amount - MID_DEDUCTION_LIMIT;
  const highDeduction = Math.floor(
    (highExcess * HIGH_DEDUCTION_RATE_PERCENT) / 100,
  );
  details.push({
    label: `${formatManWon(highExcess)}만 원 x ${HIGH_DEDUCTION_RATE_PERCENT}%`,
    value: highDeduction,
  });
  total += highDeduction;

  return { total, details };
};

export const calculateGiftBenefit = (amount: number) => {
  const units = Math.floor(amount / FULL_DEDUCTION_LIMIT);

  return (units * FULL_DEDUCTION_LIMIT * GIFT_VALUE_RATE_PERCENT) / 100;
};
